import { base_colorAction, base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_3xl,
  fontRegular,
  fontSupportMedium,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.OrganizationSSOConfig {
    padding: ${spacing(6)};
  }

  .sso-upgrade-header {
    ${font_3xl};
  }

  .sso-upgrade-header,
  .sso-upgrade-text {
    text-align: center;
  }

  .sso-upgrade-text {
    max-width: 460px;
  }

  .sso-upgrade-box.default {
    max-width: 460px;
    border-radius: ${spacing(4)};
    border: 1px solid ${base_colorAction};
    padding: ${spacing(4)} ${spacing(5)};

    .sso-upgrade-box-headline {
      padding-bottom: ${spacing(1)};
    }

    .arrow-left {
      rotate: 135deg;
      &:hover {
        cursor: pointer;
      }
    }
  }

  .box-container {
    width: 100%;
  }

  .box-content {
    padding: ${spacing(5)} ${spacing(4)};
  }

  .box-heading-subtitle {
    padding-top: ${spacing(3)};
  }

  .box-item {
    border-top: 1px solid ${base_colorContentBorder};
    margin-top: ${spacing(5)};
  }

  .box-item-content {
    padding: ${spacing(5)} 0;
  }

  .box-item-title {
    ${fontRegular}
    padding-bottom: ${spacing(2)};
    &.with-space {
      padding-top: ${spacing(5)};
    }
  }

  .box-item-subtitle {
    ${fontSupportMedium}
  }
`
